// What a product with no picture shows instead, on the client side.
//
// The same image as backend/utils/productImage.js, which is what the API now
// substitutes on read. This copy exists for the handful of places that build an
// <img src> themselves rather than taking the API's value -- the admin product
// thumbnail, the checkout line item, the product detail gallery -- so that none
// of them reach for a third-party URL again.
//
// It replaced `https://via.placeholder.com/...`, a free image service that is
// unreliable to the point of being dead. Every product without a photo pointed
// at a URL that could not load, and the service worker logged a Workbox
// `no-response` rejection each time it tried to fetch one.
//
// A data URI, not a file in public/: this string has to resolve from the web
// app (served from the site's origin), from the packaged Capacitor app (served
// from https://localhost with the API on another host), and from the admin. A
// relative path would have to exist under two different document roots to work
// in all three. This needs no host, no request and no service worker, so it can
// neither 404 nor be slow. The CSP already allows `data:` in img-src.
export const PRODUCT_IMAGE_PLACEHOLDER =
  'data:image/svg+xml;charset=UTF-8,'
  + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="260" viewBox="0 0 400 260" role="img" aria-label="No product photo">'
    + '<rect width="400" height="260" fill="#EEF1F5"/>'
    + '<g fill="none" stroke="#9AA6B8" stroke-width="6" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M200 96l46 26v52l-46 26-46-26v-52z"/>'
    + '<path d="M154 122l46 26 46-26"/>'
    + '<path d="M200 148v52"/>'
    + '</g>'
    + '</svg>'
  );

// For an <img onError>. Swapping `src` to a URL that is itself failing is what
// the admin thumbnail used to do -- it pointed the fallback at the same dead
// via.placeholder.com address, so the browser retried it forever. Guarded so it
// can only fire once per element: assigning `src` triggers another load, and if
// that load also failed we would be straight back here.
export function fallbackToPlaceholder(event) {
  const img = event.currentTarget;
  if (img.dataset.placeheld === '1') return;
  img.dataset.placeheld = '1';
  img.removeAttribute('srcset');
  img.src = PRODUCT_IMAGE_PLACEHOLDER;
}
